<template>
  <div>
    <section class="offer-section pc-offer" id="offer-section">
      <div class="offer">
        <header class="offer-section-header section-title-wrapper">
          <h1 class="section-title" v-text="$t('home.offer_title')"></h1>
          <h2 class="section-sub-title" v-text="$t('home.offer_sub_title')"></h2>
        </header>
        <div class="circle-wrapper" @mouseover="stopRotate()" @mouseout="keepRotate()">
          <div class="circle" :style="{transform:'rotate('+outterRotate+'deg)'}">
            <ul class="offer-list">
              <li
                class="offer-list-item active"
                @click="activeSelection(0)"
                v-text="$t('offer.offer1')"
              ></li>
              <li
                class="offer-list-item"
                @click="activeSelection(1)"
                v-text="$t('offer.offer2')"
              ></li>
              <li
                class="offer-list-item"
                @click="activeSelection(2)"
                v-text="$t('offer.offer3')"
              ></li>
              <li
                class="offer-list-item"
                @click="activeSelection(3)"
                v-text="$t('offer.offer4')"
              ></li>
            </ul>
          </div>
          <div class="circle-inner" :style="{transform:'rotate('+innerRotate+'deg)'}"></div>
          <div class="offer-content-wrapper active">
            <div class="offer-content">
              <div class="offer-title" v-text="offerShowObj.title"></div>
              <div class="offer-des-wrapper" v-if="offerShowObj.des">
                <div class="offer-des" v-text="offerShowObj.des"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="wap-about-offer-container" id="wap_about">
      <div class="about-container">
        <header class="wap-title-wrapper">
          <div class="wap-title-left">
            <div class="wap-section-title" v-text="$t('home.about_us_title')"></div>
            <div class="wap-section-sub-title" v-text="$t('home.about_us_sub_title')"></div>
          </div>
        </header>
        <div class="about-content">
          <div class="about-des-title" v-text="$t('home.what_is_mixmarvel')"></div>
          <div class="about-des-subtitle" v-text="$t('home.mixmarvel_exp1')"></div>
          <div class="about-des-p" v-text="$t('home.mixmarvel_exp2')+$t('home.mixmarvel_exp3')"></div>
        </div>
        <div class="video-btn" @click="showVideo">
          <img src="../../../assets/img/wap/play.png" alt="play_btn" class="video-btn-img" />
        </div>
      </div>
      <div class="offer-container">
        <header class="wap-title-wrapper">
          <div class="wap-title-left">
            <div class="wap-section-title" v-text="$t('home.offer_title')"></div>
            <div class="wap-section-sub-title" v-text="$t('home.offer_sub_title')"></div>
          </div>
        </header>
        <div class="offer-content">
          <div class="swiper-container swiper-container-offer">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in offerArray" :key="item.id">
                <div class="offer-item-box">
                  <div class="offer-item-name" v-text="item.name"></div>
                  <div class="offer-item-content">
                    <div class="offer-item-title" v-text="item.title"></div>
                    <div class="offer-item-des" v-text="item.des"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination-offer swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="wap-video-container">
      <div class="wap-video-header">
        <div class="close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <video
        :src="video_url"
        poster="../../../assets/img/video_thum.png"
        v-text="$t('video_support')"
        id="wap_video"
        controls="true"
      ></video>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import arctext from "../../../assets/js/lib/jquery.arctext";
import { animationScroll } from "@/assets/js/common";
export default {
  data() {
    return {
      offerArray: [
        {
          id: "0",
          name: this.$i18n.t("offer.offer1"),
          title: this.$i18n.t("offer.offer1_title"),
          des: this.$i18n.t("offer.offer1_des")
        },
        {
          id: "1",
          name: this.$i18n.t("offer.offer2"),
          title: this.$i18n.t("offer.offer2_title"),
          des: this.$i18n.t("offer.offer2_des")
        },
        {
          id: "2",
          name: this.$i18n.t("offer.offer3"),
          title: this.$i18n.t("offer.offer3_title"),
          des: this.$i18n.t("offer.offer3_des")
        },
        {
          id: "3",
          name: this.$i18n.t("offer.offer4"),
          title: this.$i18n.t("offer.offer4_title"),
          des: this.$i18n.t("offer.offer4_des")
        }
      ],
      offerShowObj: {},
      outterRotate: 1,
      innerRotate: 1,
      interval: null,
      swiperoffer: null,
      video_url:'https://cn-hangzhou-h-website-prod-1.obs.cn-east-3.myhuaweicloud.com/video/MixMarvel_1080p_0816Final_cn.mp4',
    };
  },
  methods: {
    //如果点击的是其它的选项则执行旋转圆动画
    activeSelection(index) {
      var _this = this;
      if (_this.offerShowObj.id == index) {
        return;
      }
      _this.switchAnimation(index);
      var oldOutterRotate = _this.outterRotate;
      var oldInnerRotate = _this.innerRotate;
      switch (index) {
        case 0:
          if (oldOutterRotate % 360 >= 180) {
            _this.outterRotate = Math.ceil(oldOutterRotate / 360) * 360;
          } else {
            _this.outterRotate = parseInt(oldOutterRotate / 360) * 360;
          }

          var num = _this.outterRotate - oldOutterRotate;
          _this.innerRotate = oldInnerRotate - num;
          break;

        case 1:
          if (oldOutterRotate % 360 < 280) {
            _this.outterRotate = parseInt(oldOutterRotate / 360) * 360 + 100;
          } else {
            _this.outterRotate = Math.ceil(oldOutterRotate / 360) * 360 + 100;
          }
          var num = _this.outterRotate - oldOutterRotate;
          _this.innerRotate = oldInnerRotate - num;
          break;

        case 2:
          if (oldOutterRotate % 360 < 180) {
            _this.outterRotate = parseInt(oldOutterRotate / 360) * 360 + 180;
          } else {
            _this.outterRotate = parseInt(oldOutterRotate / 360) * 360 + 180;
          }
          var num = _this.outterRotate - oldOutterRotate;
          _this.innerRotate = oldInnerRotate - num;
          break;

        case 3:
          if (oldOutterRotate % 360 >= 105 && oldOutterRotate % 360 < 285) {
            _this.outterRotate = parseInt(oldOutterRotate / 360) * 360 + 285;
          } else {
            _this.outterRotate = parseInt(oldOutterRotate / 360) * 360 - 70;
          }
          var num = _this.outterRotate - oldOutterRotate;
          _this.innerRotate = oldInnerRotate - num;
          break;

        default:
          break;
      }
    },
    switchAnimation(index) {
      var _this = this;
      if (_this.offerShowObj.id == index) {
        return;
      }
      $(".offer-list-item").removeClass("active");
      $(".offer-content-wrapper").removeClass("active");
      $(".offer-list-item")
        .eq(index)
        .addClass("active");
      _this.offerShowObj = {};
      setTimeout(function() {
        _this.offerShowObj = _this.offerArray[index];
        $(".offer-content-wrapper").addClass("active");
      }, 500);
      this.scrollDes();
    },
    init() {
      var _this = this;
      _this.offerShowObj = _this.offerArray[0];
      _this.setArctext();
      window.addEventListener(
        "resize",
        function() {
          _this.setArctext();
        },
        false
      );
      setTimeout(function() {
        _this.initOfferSwiper();
      }, 500);
      _this.keepRotate();
    },
    //使字体产生弧度
    setArctext() {
      setTimeout(function() {
        $(".offer-list-item").arctext({
          radius: 220
        });
      }, 500);
    },
    keepRotate() {
      var _this = this;
      _this.interval = setInterval(function() {
        if (_this.outterRotate % 360 == 0) {
          _this.switchAnimation(0);
        }
        if (_this.outterRotate % 360 == 100) {
          _this.switchAnimation(1);
        }
        if (_this.outterRotate % 360 == 180) {
          _this.switchAnimation(2);
        }
        if (_this.outterRotate % 360 == 285) {
          _this.switchAnimation(3);
        }
        _this.outterRotate++;
        _this.innerRotate--;
      }, 150);
    },
    stopRotate() {
      clearInterval(this.interval);
    },
    scrollDes() {
      var scrollHeight = $(".offer-des").prop("scrollHeight");
      setTimeout(function() {
        $(".offer-des-wrapper").animate({ scrollTop: scrollHeight }, 10000);
      }, 1000);
    },
    initOfferSwiper() {
      var _this = this;
      this.swiperoffer = new Swiper(".swiper-container-offer", {
        autoplay: {
          delay: 5000
        },
        speed: 500,
        slidesPerView: 1, //重要 可以去swiper搜索
        centeredSlides: true, //重要
        initialSlide: 0,
        spaceBetween: 35,
        effect: "left",
        observer:true,
        observeParents:true,
        disableOnInteraction: false,
        pagination: {
          el: ".swiper-pagination-offer",
          clickable: true
        },
        on:{
          slideChange: function() {
            var activeIndex = this.activeIndex;
            $('.swiper-container-offer .swiper-slide').find('.offer-item-des').stop();
            _this.scrollOffer(activeIndex);
          }
        }
      });
    },
    showVideo(){
      $('.wap-video-container').fadeIn();
      var videoDom = document.getElementById('wap_video');
      videoDom.play();
    },
    closeVideo(){
      $('.wap-video-container').fadeOut();
      var videoDom = document.getElementById('wap_video');
      if (!videoDom.paused) {
        videoDom.load();
      }
    },
    scrollOffer(index){
      var desDom = $('.swiper-container-offer .swiper-slide').eq(index).find('.offer-item-des');
      if (desDom.scrollTop()>0) {
        desDom.animate({ scrollTop: 0}, 0);
      }
      var desScrollHeight = desDom.prop("scrollHeight");
      desDom.animate({ scrollTop: desScrollHeight }, 10000);
      desDom.scroll(function(){
          // scroll at bottom
          if (desDom.scrollTop()+desDom.height()>=desScrollHeight-2) {
            desDom.stop();
          }
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
    animationScroll($(".offer"));
    $('#wap_video').css('width',window.innerHeight);
    var lang = this.$cookies.get('language');
    if(lang == 'en'||lang == 'kr'){
      this.video_url = 'https://cn-hangzhou-h-website-prod-1.obs.cn-east-3.myhuaweicloud.com/video/MixMarvel_1080p_0816Final_en.mp4'
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pc/index/offerSection.vue